import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { isOutlookMessage } from '@aid/shared/utils/upload-file-type';

@Injectable({
  providedIn: 'root'
})
export class FileService<T> {
  protected constructor(protected http: HttpClient) {}

  viewFile(url: string) {
    return this.http.get<string>(url).subscribe(value => window.open(value));
  }

  /*fileUploadObject(object: T, file?: File): Observable<T> {
    if (file && object.uploadSignedUrl) {
      return this.upload(file, object.uploadSignedUrl).pipe(map(() => object));
    }
    return of(object);
  }*/

  fileUploadObject(object: T, file?: File, signedUrl?: string): Observable<T> {
    if (!file) {
      return of(object);
    }

    const uploadUrl = signedUrl || this.uploadSignedUrlOf(object);
    if (!uploadUrl) {
      return throwError(() => new Error('The file upload URL is missing.'));
    }

    return this.upload(file, uploadUrl).pipe(map(() => object));
  }

  private uploadSignedUrlOf(object: T): string | undefined {
    if (
      typeof object === 'object' &&
      object !== null &&
      'uploadSignedUrl' in object &&
      typeof object.uploadSignedUrl === 'string'
    ) {
      return object.uploadSignedUrl;
    }
    return undefined;
  }

  private upload(file: File, url: string) {
    if (isOutlookMessage(file.name)) {
      return this.http.put(url, file, {
        headers: {
          'Content-Type': 'application/vnd.ms-outlook'
        }
      });
    } else {
      return this.http.put(url, file);
    }
  }

  downloadFile(baseUrl: string, fileName: string) {
    return this.http.get<any>(baseUrl).pipe(
      map(value => value),
      switchMap(url => this.http.get(url, { responseType: 'blob' })),
      tap(blob => {
        this.download(blob, fileName);
      })
    );
  }

  download(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);

    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();

    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
